import HostedLoadingState from '../../../components/hosted/LoadingState';
import { useTranslation } from '../../../i18n/i18n';

export default function HostedInitScreen() {
  const { t } = useTranslation();
  return (
    <HostedLoadingState title={t('init.title')} subtitle={t('init.hint')} />
  );
}
